<ng-container>
    @if (isShowFooter) {
    <!-- Main Footer -->
    <footer role="contentinfo" class="bg-[#20639B] text-white">
        <div class="mx-auto w-full max-w-[2500px] px-[clamp(1rem,5vw,10rem)]">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-8 py-10 border-b border-white/10">
                <!-- About Us (6/12) -->
                <div class="md:col-span-6">
                    <div class="flex items-center gap-3 flex-shrink-0 mb-6">
                        <img src="../../../../assets/img/SIERA-White-New.svg" alt="Logo"
                            class="h-[40px] xl:h-[60px] cursor-pointer" [routerLink]="['/home']" />
                    </div>
                    <p class="leading-relaxed text-white/90 text-[clamp(16px,1vw,24px)]">
                        <b>SIERA Shop</b> is the offshoot of the <b>SIERA Shop</b>, We take care of the
                        procurement and administration of SIERA Shop's assets.
                    </p>
                    <p class="mt-3 leading-relaxed text-white/90 text-[clamp(16px,1vw,24px)]">
                        Our products are tailored only to the needs of <b>SIERA Shop</b>.
                    </p>
                </div>
                <!-- Useful Links (2/12) -->
                <div class="md:col-span-2">
                    <h5 class="text-[clamp(16px,1vw,24px)] font-semibold uppercase tracking-wider text-white/80 mb-4">
                        Useful Links
                    </h5>
                    <ul class="space-y-3 text-[clamp(16px,1vw,24px)]">
                        <li>
                            <a routerLink="/" class="hover:underline underline-offset-4 decoration-white/60">
                                Home
                            </a>
                        </li>
                        <!-- <li>
                            <a routerLink="/privacy" class="hover:underline underline-offset-4 decoration-white/60">
                                Privacy
                            </a>
                        </li> -->
                        <li>
                            <a routerLink="/contact-us" class="hover:underline underline-offset-4 decoration-white/60">
                                Contact Us
                            </a>
                        </li>
                        <li>
                            <a routerLink="/privacy" class="hover:underline underline-offset-4 decoration-white/60">
                                Privacy
                            </a>
                        </li>
                        <li>
                            <a routerLink="/terms-and-conditions"
                                class="hover:underline underline-offset-4 decoration-white/60">
                                Policies
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- Get in Touch (4/12) -->
                <div class="md:col-span-4">
                    <h5 class="text-[clamp(16px,1vw,24px)] font-semibold uppercase tracking-wider text-white/80 mb-4">
                        Get in Touch
                    </h5>
                    <ul class="space-y-3 text-[clamp(16px,1vw,24px)]">
                        <li class="flex items-center gap-3">
                            <!-- Phone Icon -->
                            <svg class="w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path
                                    d="M2 6.5C2 5.12 3.12 4 4.5 4h2A2.5 2.5 0 0 1 9 6.5v1A2.5 2.5 0 0 1 6.5 10h0c.6 2.34 2.56 4.3 4.9 4.9v0A2.5 2.5 0 0 1 14 17.5v1A2.5 2.5 0 0 1 11.5 21h-2C4.91 21 2 18.09 2 14.5v-8Z"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                            <a href="tel:+49802218808883" class="hover:underline break-all">+49 8022 18808883</a>
                        </li>
                        <li class="flex items-center gap-3">
                            <!-- Mail Icon -->
                            <svg class="w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path
                                    d="M3 6.75A2.75 2.75 0 0 1 5.75 4h12.5A2.75 2.75 0 0 1 21 6.75v10.5A2.75 2.75 0 0 1 18.25 20H5.75A2.75 2.75 0 0 1 3 17.25V6.75Z"
                                    stroke="currentColor" stroke-width="1.5" />
                                <path d="M4 7l8 6 8-6" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" />
                            </svg>
                            <a href="mailto:administration@siera.com" class="hover:underline break-all">
                                administration&#64;siera.com
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>

    <!-- Small Footer -->
    <!-- <div class="bg-[#20639B]">
        <div class="mx-auto w-full max-w-[2500px] px-[clamp(1rem,5vw,10rem)]">
            <div class="py-3 text-center text-white text-sm">
                copyright © SIERA Shop
            </div>
        </div>
    </div> -->
    }
</ng-container>